import React, { useState } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { Flex, Button, Checkbox, TextArea } from "@fluentui/react-northstar";
import { useApp } from "../../contexts/appContext";
import styles from "./commonModal.module.scss";

const ConfirmResolveProject = () => {
  const params = new URLSearchParams(window.location.search);
  const sendEmailParam = params.get("showSendEmail");
  const contactEmailParam = params.get("contactEmail");
  const slaActiveParam = params.get("slaActive");
  const [resolution, setResolution] = useState("");
  const [sendEmail, setSendEmail] = useState(true);
  const [secondCallDone, setSecondCallDone] = useState(false);
  const { state: appState } = useApp();
  const { isDarkTheme } = appState;

  const confirmDialog = () => {
    const resolutionHtml = resolution.replace(/[\n]+/g, "<br />");
    const data = { resolution: resolutionHtml, sendEmail: sendEmail && !!contactEmailParam, secondCallDone };
    microsoftTeams.dialog.url.submit(data);
  }

  return (
    <Flex gap="gap.medium" column className={styles.container} style={{ backgroundColor: isDarkTheme ? "#292929" : "#FFFFFF" }}>
      <Flex column>
        <TextArea
          placeholder="Popis řešení"
          value={resolution}
          rows={6}
          onChange={(_: any, data: any) => setResolution(data.value)}
        />
        {sendEmailParam && sendEmailParam === "true" &&
          <Flex column>
            <Checkbox
              label="Odeslat emailem zákazníkovi"
              defaultChecked={sendEmail}
              disabled={!contactEmailParam}
              onChange={(_: any, data: any) => setSendEmail(data.checked)}
            />
            <small>Kontakt: {!contactEmailParam ? "N/A" : contactEmailParam}</small>
          </Flex>
        }
        {slaActiveParam && slaActiveParam === "true" &&
          <Flex column>
            <Checkbox
              label="Second Call Done"
              onChange={(_: any, data: any) => setSecondCallDone(data.checked)}
            />
            <small>Follow Up SLA stále běží. Je nutné kontaktovat zákazníka o vyřešení případu.</small>
          </Flex>
        }
      </Flex>

      <Flex>
        <Flex fill></Flex>
        <Flex gap="gap.medium">
          <Button content="Zrušit" onClick={() => microsoftTeams.dialog.url.submit()} />
          <Button content="Potvrdit" primary onClick={confirmDialog} disabled={!resolution} />
        </Flex>
      </Flex>

    </Flex>
  );
};

export default ConfirmResolveProject;
